import { DatePipe } from '@angular/common';
import { HostListener } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ConfigetiquetaService } from '../../servicios/configetiqueta.service';
import { ImpresionService } from '../../servicios/impresion.service';
import { OrdenService } from '../../servicios/orden.service';

import { FormControl } from '@angular/forms';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { NgSelectConfig } from '@ng-select/ng-select';
import { EtiquetaModule } from '../../modelo/etiqueta/etiqueta.module';
import { ProductoModule } from '../../modelo/producto/producto.module';
import { ClienteModule } from '../../modelo/cliente/cliente.module';
import { BatchModule } from '../../modelo/batch/batch.module';
import { ConfigEtiquetaModule } from '../../modelo/confiEtiqueta/batch.module';


@Component({
  selector: 'app-configetiqueta',
  templateUrl: './configetiqueta.component.html',
  styleUrls: ['./configetiqueta.component.css']
})
export class ConfigetiquetaComponent implements OnInit {

  
  fecha: string;
  batch:BatchModule[];
  lista: EtiquetaModule[];
  listaEtiqueta: EtiquetaModule[];
  listaProducto: ProductoModule[];
  listaCliente: ClienteModule[];
  listaConfigEtiqueta: ConfigEtiquetaModule[];
  searchText: string = '';
  cliente:string;
  producto:string;
  etiqueta:EtiquetaModule;
  nombreEtiqueta:string;
  filteredOptions: Observable<any[]>;
  etiquetas: string[] = ['Canada','Certificacion', 'CostoPequena', 'GoodFarma_asobananito', 'GoodFarma_asoagcar', 'Satori', 'Satori Maritimo', 'freshkita', 'Organico'];
  /** control for the MatSelect filter keyword */
  public siteFilterCtrl: FormControl = new FormControl();
  searchInput = new FormControl('');
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
 
  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationDet: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableDet: MdbTableDirective;
  previous: any = [];
  @ViewChild('lgModal') public lgModal: ModalDirective;
  @ViewChild('singleSelect') singleSelect: MatSelect;
  protected _onDestroy = new Subject<void>();

  /** control for the selected bank */
  public bankCtrl: FormControl = new FormControl();

  cars = [
    { id: 1, name: 'Volvo' },
    { id: 2, name: 'Saab' },
    { id: 3, name: 'Opel' },
    { id: 4, name: 'Audi' },
];

  /** control for the MatSelect filter keyword */
  public bankFilterCtrl: FormControl = new FormControl();

  selectedPersonId = '5a15b13c36e7a7f00cf0d7cb';


  
  constructor(private sanitizer: DomSanitizer,private apiPrint: ConfigetiquetaService,private datePipe: DatePipe,private api: OrdenService, private ruter: Router,private alertService: AlertService,
    private config: NgSelectConfig) {
      this.config.notFoundText = 'No se encuenta';
      this.config.appendTo = 'body';
      // set the bindValue to global config when you use the same 
      // bindValue in most of the place. 
      // You can also override bindValue for the specified template 
      // by defining `bindValue` as property
      // Eg : <ng-select bindValue="some-new-value"></ng-select>
      this.config.bindValue = 'value';
  
  }

 listarEtiquetas()
 {

  this.searchText='';
  this.apiPrint.listar()
    .subscribe((
      data: EtiquetaModule[]) => {
      this.lista = data;
      console.log(this.lista);
   
      this.mdbTable.setDataSource(this.lista);
      this.mdbTable.dataSourceChange();
      this.previous = this.mdbTable.getDataSource();
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );

 }



  agregar(){
    this.listaEtiqueta= [];
    this.etiqueta = new EtiquetaModule();
  
    this.etiqueta.etiquetaNombre=this.nombreEtiqueta;
    this.listaProducto.forEach(element => {
      if (this.producto===element.value){
      this.etiqueta.name_producto=element.name
      this.etiqueta.m_product_id=element.m_product_id
      }
    }
    );
    this.listaCliente.forEach(element => {
      if (this.cliente===element.value){
      this.etiqueta.name_proveedor=element.name
      }
    });
    this.etiqueta.producto=this.producto;
    this.etiqueta.provedor_identificacion=this.cliente;
    this.listaEtiqueta.push(this.etiqueta);
    console.log(this.listaEtiqueta)
    this.apiPrint.registrar(this.listaEtiqueta).subscribe((
      data) => {
        
        this.alertService.info("Se guardo con exito...")
        this.listarEtiquetas();
    },
    err => 
    this.alertService.close(err)
    
    
    );    


  }
  ngOnInit(): void {
    this.lista= [];
   this.buscarCliente();
   this.buscarProducto();
   this.listarEtiquetas();
   this.buscarConfigEtiquetas();
   
  }

  @HostListener('input') oninput() {
    this.searchItems();
  }
  

  eliminar(entidad:EtiquetaModule){
      this.apiPrint.eliminar(entidad).subscribe((
      data) => {
      this.listarEtiquetas();
      this.alertService.success('Se elimino con exito...');
      },
      err => this.listarEtiquetas()
    );
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.lista = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.lista = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }



  buscarEtiquetas()
  {
    this.searchText='';
    this.apiPrint.listar()
      .subscribe((
        data: EtiquetaModule[]) => {
        this.lista = data;
        console.log(this.lista);
     
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }

  buscarConfigEtiquetas()
  {
    this.searchText='';
    this.apiPrint.listarConfigEtiqueta()
      .subscribe((
        data: ConfigEtiquetaModule[]) => {
        this.listaConfigEtiqueta = data;
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }

  buscarProducto()
  {
    this.searchText='';
    this.apiPrint.listarProducto()
      .subscribe((
        data: ProductoModule[]) => {
        this.listaProducto = data;
       
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }
  
  buscarCliente()
  {
    this.searchText='';
    this.apiPrint.listarCliente()
      .subscribe((
        data: ClienteModule[]) => {
        this.listaCliente = data;
     
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
  }

  

}
